export const COMMUNITY_API_PREFIX = '/api/community/community'
export const COMMENT_API_PREFIX = '/api/comment/comments'
export const SYSTEME_LOGO_API = 'https://d2543nuuc0wvdg.cloudfront.net/images/logo_md.svg'
export const INNER_API = process.env.SIO_INNER_HOST
